// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"cpf-validation_modalContent__om8Sk"};